import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',         // 'idle' | 'loading' | 'ready' | 'failed'
  notifications: [],
  dismissedIds: [],       // client-side only; resets on every fetch (no backend mark-as-read endpoint)
  error: null,
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    notificationsRequested(state, action) {
      if (!(state.status === 'ready' && action.payload?.silent)) {
        state.status = 'loading';
      }
      state.error = null;
    },
    notificationsLoaded(state, action) {
      state.status = 'ready';
      state.notifications = action.payload ?? [];
      // Fresh fetch implies fresh dismiss state — reset.
      state.dismissedIds = [];
    },
    notificationsLoadFailed(state, action) {
      state.status = 'failed';
      state.error = action.payload ?? 'Failed to load notifications';
    },
    notificationDismissed(state, action) {
      const id = action.payload;
      if (!state.dismissedIds.includes(id)) {
        state.dismissedIds.push(id);
      }
    },
    notificationsSliceReset() {
      return initialState;
    },
  },
});

export const {
  notificationsRequested,
  notificationsLoaded,
  notificationsLoadFailed,
  notificationDismissed,
  notificationsSliceReset,
} = slice.actions;
export const notificationsReducer = slice.reducer;
